import styled, { css } from "styled-components";
import { getCssForMobileView } from "styles/responsive";

export const PartnerInformationSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PartnerTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: ${({ theme }) => theme.primaryColor};
`;

export const PartnerSubtitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  color: ${({ theme }) => theme.grey["800"]};
`;

export const PartnerSection = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
`;

export const HubPartnerInformationSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  ${getCssForMobileView(css`
    justify-content: center;
  `)}
`;

export const HubPartnerText = styled.p`
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  color: ${({ theme }) => theme.grey["800"]};
`;
